










































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DepositModel } from '@/models/deposit';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class AmountDetailDeposit extends Vue {
    @Prop({ default: () => new DepositModel() })
    private deposit!: DepositModel;

    get payment() {
        return this.deposit.payment > 0 ? formatNumber(this.deposit.payment, '0,0') : '0';
    }
}
